import { gray40opacity20 } from '../../../colors/gray';
export var MuiCircularProgress = {
    styleOverrides: {},
    customOverrides: {
        bottom: {
            color: gray40opacity20,
        },
    },
};
